import React from 'react'

export const ResendInviteIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6667 6.33333V3.16667C12.6667 2.43029 12.0697 1.83333 11.3333 1.83333H2.66667C1.93029 1.83333 1.33333 2.43029 1.33333 3.16667V9.83333C1.33333 10.5697 1.93029 11.1667 2.66667 11.1667H8"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M1.66667 3.5L7 7.16667L12.3333 3.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 10.5H14.6667M14.6667 10.5L13 8.83333M14.6667 10.5L13 12.1667"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
